/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutNotificationSpec } from './rolloutNotificationSpec';
import { RolloutWaveState } from './rolloutWaveState';


export interface RolloutWaveUpdateRequest { 
    /**
     * User friendly name for the wave.
     */
    name?: string;
    /**
     * Internal name for the wave, only visible to operator.
     */
    internal_name?: string;
    /**
     * scheduled execution start time for the wave.
     */
    window_start_time?: Date;
    /**
     * scheduled execution end time for the wave.
     */
    window_end_time?: Date;
    /**
     * List of notifications spec to be created.
     */
    notification_spec?: Array<RolloutNotificationSpec>;
    state?: RolloutWaveState;
}
export namespace RolloutWaveUpdateRequest {
}


